import definition from './customers.service';

/**
 * CustomersApi settings
 * @type {{name: string, definition: CustomersApi}}
 */
export default {
    name: 'CustomersApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/customers/index.js